angular.module('impactx.rfx').service('RFXThreadSaveService', [
    'dataGen',
    'ToastService',
    'TranslationService',
    'BackService',
    'OutsourcedCommentSaveService',
    RFXThreadSaveService
]);

function RFXThreadSaveService(dataGen, ToastService, TranslationService, BackService, OutsourcedCommentSaveService) {

    function saveData(scope) {
        var extractedComments = OutsourcedCommentSaveService.extractComments(scope.data);

        var dataObj = {
            data: scope.data
        };

        return dataGen.postAsForm({}, dataObj, "/rfx/thread/save").then(function (response) {
            if (response && response.data) {
                scope.data.id = response.data.id;
                return OutsourcedCommentSaveService.saveComments(response.data.comments, extractedComments, true);
            }
        }, function () {
            OutsourcedCommentSaveService.restoreComments(scope.data, extractedComments);
        });
    }

    function notifyUsers(rfqhThreadId, isNewObject, supplierUser) {
        return dataGen.postAsForm({}, {rfqhThreadId: rfqhThreadId, isNewObject: isNewObject, supplierUser: supplierUser}, '/rfx/thread/notify');
    }

    return {
        saveData: saveData,
        notifyUsers: notifyUsers
    };

}